import React from 'react';
import { Stack, Typography } from '@mui/material';
import { DealActivityEventType } from '@trnsact/trnsact-shared-types';
import { SvgIconComponent, Place, Phone, Videocam, Event } from '@mui/icons-material';

interface Props {
  type: DealActivityEventType;
}

const TYPE_ICONS: Record<DealActivityEventType, SvgIconComponent> = {
  [DealActivityEventType.Other]: Event,
  [DealActivityEventType.PhoneCall]: Phone,
  [DealActivityEventType.VideoCall]: Videocam,
  [DealActivityEventType.InPersonVisit]: Place,
};

const EVENT_TYPE_LABELS: Record<DealActivityEventType, string> = {
  [DealActivityEventType.Other]: 'Other',
  [DealActivityEventType.PhoneCall]: 'Phone call',
  [DealActivityEventType.VideoCall]: 'Video call',
  [DealActivityEventType.InPersonVisit]: 'In-person visit',
};

export const EventTypeCell = ({ type }: Props) => {
  const Icon = TYPE_ICONS[type] ?? Event;

  return (
    <Stack direction="row" alignItems="center" gap="0.5rem">
      <Icon fontSize="small" color="action" />
      <Typography variant="body2">{EVENT_TYPE_LABELS[type] ?? type}</Typography>
    </Stack>
  );
};
